export enum ExtendedDataKey{
    ArrivalComments = 'Arrival Comments',
    ArrivalStation = 'Arrival Station',
    ArrivalStationCode = 'Arrival Station Code',
    BaggageTag = 'BaggageTag',
    DepartureComments = 'Departure Comments',
    MarketCode = 'Market Code',
    RateCode = 'Rate Code',
    FlightCode = 'Flight Code',
    FlightNumber = 'Flight Number'
}

export enum ExtendedDataLabels{
    ArrivalComments = 'LBL.ARRIVAL_COMMENTS',
    ArrivalStation = 'LBL.ARRIVAL_STATION',
    ArrivalStationCode = 'LBL.ARRIVAL_STATION_CODE',
    BaggageTag = 'LBL.BAGGAGE_TAG',
    DepartureComments = 'LBL.DEPARTURE_COMMENTS',
    MarketCode = 'LBL.MARKET_CODE',
    RateCode = 'LBL.RATE_CODE',
    FlightCode = 'LBL.FLIGHT_CODE',
    FlightNumber = 'LBL.FLIGHT_NUMBER'
}